import { render, staticRenderFns } from "./columnstore_viewer_body_cell.vue?vue&type=template&id=d4b4fad0&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports